import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Syncfusion license registration
import { registerLicense } from '@syncfusion/ej2-base';
// Syncfusion styles
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-react-richtexteditor/styles/material.css';
import '@syncfusion/ej2-react-dropdowns/styles/material.css';
import '@syncfusion/ej2-react-calendars/styles/material.css';
import '@syncfusion/ej2-react-navigations/styles/material.css';
import '@syncfusion/ej2-react-grids/styles/material.css';
import '@syncfusion/ej2-react-interactive-chat/styles/material.css';
import '@syncfusion/ej2-react-buttons/styles/material.css';
import '@syncfusion/ej2-react-popups/styles/material.css';
import '@syncfusion/ej2-react-notifications/styles/material.css';
// Custom RichTextEditor styling overrides
import './components/UI/RichTextEditor.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { suppressExtensionConsoleNoise } from './utils/suppressExtensionConsoleNoise';

suppressExtensionConsoleNoise();

const syncfusionLicense = process.env.REACT_APP_SYNCFUSION_LICENSE || 'Ngo9BigBOggjHTQxAR8/V1JAaF5cX2pCd1p/TH5YfUNzdUVEY1ZUTXxaS1ZhSXxVdkJhUX5bdHNXRWVVV0d9XEY=';
try {
    registerLicense(syncfusionLicense);
} catch (err) {
    console.warn('Failed to register Syncfusion license:', err);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
